export const DATA = [
  {
    title_ka: "მთავარი",
    title_en: "Home",
    id: 0,
    sectionName: "home",
    path: "/",
  },
  {
    title_ka: "ჩვენს შესახებ",
    title_en: "About Us",
    id: 1,
    sectionName: "aboutUs",
    path: "/aboutUs",
  },
  {
    title_ka: "მენიუ",
    title_en: "Menu",
    id: 3,
    sectionName: "menu",
    path: "/menu",
  },
  {
    title_ka: "პარტნიორები",
    title_en: "Partners",
    id: 4,
    sectionName: "partnership",
    path: "/#partnership",
  },
  {
    title_ka: "კონტაქტი",
    title_en: "Contact us",
    id: 5,
    sectionName: "contactUs",
    path: "/contactUs",
  },
];
